(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["also-to-buy"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var section = document.querySelector('.atb');
    if (!section) return;

    var track = section.querySelector('.atb__track');
    var progress = section.querySelector('.product-slider__progress-fill');
    var btnPrev = section.querySelector('.product-slider__btn-nav--prev');
    var btnNext = section.querySelector('.product-slider__btn-nav--next');

    if (!track || !btnPrev || !btnNext) return;
    if (window.innerWidth <= 768) return;

    var cards = track.querySelectorAll('.atb__card');
    var total = cards.length;
    var current = 0;
    var visibleCount = window.innerWidth <= 1024 ? 2 : 3;
    var maxIndex = Math.max(0, total - visibleCount);

    function getCardWidth() {
      var gap = parseInt(getComputedStyle(track).gap) || 0;
      return cards[0] ? cards[0].offsetWidth + gap : 0;
    }

    function update() {
      track.style.transform = 'translateX(-' + current * getCardWidth() + 'px)';
      var thumbWidth = total <= visibleCount ? 100 : (visibleCount / total) * 100;
      var thumbLeft = total <= visibleCount ? 0 : (current / maxIndex) * (100 - thumbWidth);
      if (progress) {
        progress.style.width = thumbWidth + '%';
        progress.style.left = thumbLeft + '%';
      }
      btnPrev.classList.toggle('is-inactive', current === 0);
      btnNext.classList.toggle('is-inactive', current >= maxIndex);
    }

    btnPrev.addEventListener('click', function () {
      if (current > 0) {
        current--;
        update();
      }
    });

    btnNext.addEventListener('click', function () {
      if (current < maxIndex) {
        current++;
        update();
      }
    });

    update();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer-dwd"]) return;
  try {
    
  (function () {
    if (window.__dwdCartDrawerInit) return;
    window.__dwdCartDrawerInit = true;

    var root, panel, body, foot, subtotalEl, countEl, shipBar, shipText, shipFill;
    var moneyFormat, directCheckout, interceptAdd, freeShipping, freeThreshold, continueUrl;
    var lastFocus = null;
    var cartCache = null;

    /* ---- money ---- */
    function formatMoney(cents, format) {
      if (typeof cents === 'string') cents = cents.replace('.', '');
      var ph = new RegExp('\\{\\{\\s*(\\w+)\\s*\\}\\}');
      function delim(number, precision, thousands, decimal) {
        precision = precision == null ? 2 : precision;
        thousands = thousands == null ? ',' : thousands;
        decimal = decimal == null ? '.' : decimal;
        if (isNaN(number) || number == null) return '0';
        number = (number / 100).toFixed(precision);
        var parts = number.split('.');
        var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        var frac = parts[1] ? decimal + parts[1] : '';
        return whole + frac;
      }
      var match = (format || '').match(ph);
      var token = match ? match[1] : 'amount';
      var value;
      switch (token) {
        case 'amount_no_decimals': value = delim(cents, 0); break;
        case 'amount_with_comma_separator': value = delim(cents, 2, '.', ','); break;
        case 'amount_no_decimals_with_comma_separator': value = delim(cents, 0, '.', ','); break;
        case 'amount_with_space_separator': value = delim(cents, 2, ' ', ','); break;
        case 'amount_no_decimals_with_space_separator': value = delim(cents, 0, ' ', ''); break;
        case 'amount_with_apostrophe_separator': value = delim(cents, 2, "'", '.'); break;
        default: value = delim(cents, 2);
      }
      return format ? format.replace(ph, value) : value;
    }

    function sizedImg(url, size) {
      if (!url) return '';
      return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + size;
    }

    /* ---- rendering ---- */
    function renderItems(cart) {
      if (!cart.items || cart.items.length === 0) {
        foot.hidden = true;
        if (shipBar) shipBar.hidden = true;
        body.innerHTML =
          '<div class="dwd-cart-drawer__empty">' +
          '<p>Ihr Warenkorb ist leer.</p>' +
          '<a class="dwd-cart-drawer__empty-btn" href="' + (continueUrl || '/') + '">Weiter einkaufen</a>' +
          '</div>';
        return;
      }

      var html = '';
      cart.items.forEach(function (item) {
        var vt = (item.variant_title || '').trim();
        var variant = vt && vt !== 'Default Title' && vt.toLowerCase() !== 'nan' ? vt : '';
        html +=
          '<div class="dwd-cart-item" data-key="' + item.key + '">' +
            '<a class="dwd-cart-item__media" href="' + item.url + '">' +
              (item.image ? '<img src="' + sizedImg(item.image, 160) + '" alt="" loading="lazy">' : '') +
            '</a>' +
            '<div class="dwd-cart-item__info">' +
              '<a class="dwd-cart-item__title" href="' + item.url + '">' + item.product_title + '</a>' +
              (variant ? '<div class="dwd-cart-item__variant">' + variant + '</div>' : '') +
              '<div class="dwd-cart-item__price">' + formatMoney(item.final_line_price, moneyFormat) + '</div>' +
              '<div class="dwd-cart-item__controls">' +
                '<div class="dwd-qty">' +
                  '<button type="button" data-qty-step="-1" aria-label="Menge verringern">&minus;</button>' +
                  '<span>' + item.quantity + '</span>' +
                  '<button type="button" data-qty-step="1" aria-label="Menge erh&ouml;hen">+</button>' +
                '</div>' +
                '<button type="button" class="dwd-cart-item__remove" data-remove aria-label="Entfernen">Entfernen</button>' +
              '</div>' +
            '</div>' +
          '</div>';
      });
      body.innerHTML = html;

      foot.hidden = false;
      subtotalEl.textContent = formatMoney(cart.total_price, moneyFormat);
      renderShipBar(cart.total_price);
    }

    function renderShipBar(total) {
      if (!shipBar || !freeShipping || !freeThreshold) { if (shipBar) shipBar.hidden = true; return; }
      shipBar.hidden = false;
      if (total >= freeThreshold) {
        shipText.innerHTML = 'Sie haben <b>kostenlosen Versand</b> erreicht!';
        shipFill.style.width = '100%';
      } else {
        var left = formatMoney(freeThreshold - total, moneyFormat);
        shipText.innerHTML = 'Noch <b>' + left + '</b> bis zum kostenlosen Versand';
        shipFill.style.width = Math.min(100, (total / freeThreshold) * 100) + '%';
      }
    }

    function updateCount(count) {
      if (countEl) countEl.textContent = count ? ' (' + count + ')' : '';
      document.querySelectorAll('.site-header__cart').forEach(function (link) {
        var badge = link.querySelector('.site-header__cart-count');
        if (count > 0) {
          if (!badge) {
            badge = document.createElement('span');
            badge.className = 'site-header__cart-count t-label';
            link.appendChild(badge);
          }
          badge.textContent = count;
          badge.style.display = '';
        } else if (badge) {
          badge.style.display = 'none';
        }
      });
    }

    function applyCart(cart) {
      cartCache = cart;
      renderItems(cart);
      updateCount(cart.item_count);
      document.dispatchEvent(new CustomEvent('dwd:cart:updated', { detail: cart }));
    }

    /* ---- network ---- */
    function fetchCart() {
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(applyCart);
    }

    function changeQty(key, qty) {
      root.classList.add('is-loading');
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      })
        .then(function (r) { return r.json(); })
        .then(applyCart)
        .catch(function (e) { console.error('DWDCart change error', e); })
        .then(function () { root.classList.remove('is-loading'); });
    }

    function addToCart(formData) {
      root.classList.add('is-loading');
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: formData
      })
        .then(function (r) { return r.json(); })
        .then(function () { return fetchCart(); })
        .then(function () { open(); })
        .catch(function (e) { console.error('DWDCart add error', e); })
        .then(function () { root.classList.remove('is-loading'); });
    }

    /* ---- open / close ---- */
    function open() {
      lastFocus = document.activeElement;
      root.classList.add('is-open');
      root.setAttribute('aria-hidden', 'false');
      document.body.classList.add('dwd-no-scroll');
      var closeBtn = root.querySelector('[data-cart-close]');
      if (closeBtn) closeBtn.focus();
      fetchCart();
    }
    function close() {
      root.classList.remove('is-open');
      root.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('dwd-no-scroll');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    /* ---- events ---- */
    function bind() {
      // открыть по клику на иконку корзины
      document.addEventListener('click', function (e) {
        var trigger = e.target.closest('.site-header__cart, [data-cart-open]');
        if (trigger) { e.preventDefault(); open(); return; }

        var closeEl = e.target.closest('[data-cart-close]');
        if (closeEl && root.contains(closeEl)) { e.preventDefault(); close(); return; }

        var step = e.target.closest('[data-qty-step]');
        if (step && root.contains(step)) {
          var itemEl = step.closest('.dwd-cart-item');
          var item = cartCache && cartCache.items.filter(function (i) { return i.key === itemEl.dataset.key; })[0];
          if (item) changeQty(itemEl.dataset.key, item.quantity + parseInt(step.dataset.qtyStep, 10));
          return;
        }

        var rm = e.target.closest('[data-remove]');
        if (rm && root.contains(rm)) {
          var rmItem = rm.closest('.dwd-cart-item');
          if (rmItem) changeQty(rmItem.dataset.key, 0);
          return;
        }
      });

      // Esc закрывает
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && root.classList.contains('is-open')) close();
      });

      // перехват add-to-cart форм (можно выключить в настройках секции)
      if (interceptAdd) {
        document.addEventListener('submit', function (e) {
          var form = e.target;
          if (form.tagName !== 'FORM') return;
          var action = form.getAttribute('action') || '';
          if (action.indexOf('/cart/add') === -1) return;
          if (form.hasAttribute('data-no-drawer')) return;
          e.preventDefault();
          addToCart(new FormData(form));
        }, true);
      }
    }

    /* ---- init ---- */
    function init() {
      root = document.getElementById('DWDCartDrawer');
      if (!root) return;
      panel = root.querySelector('.dwd-cart-drawer__panel');
      body = root.querySelector('[data-cart-body]');
      foot = root.querySelector('[data-cart-foot]');
      subtotalEl = root.querySelector('[data-cart-subtotal]');
      countEl = root.querySelector('[data-cart-count]');
      shipBar = root.querySelector('[data-ship-bar]');
      shipText = root.querySelector('[data-ship-text]');
      shipFill = root.querySelector('[data-ship-fill]');

      moneyFormat = root.dataset.moneyFormat || '';
      directCheckout = root.dataset.directCheckout === 'true';
      interceptAdd = root.dataset.interceptAdd === 'true';
      freeShipping = root.dataset.freeShipping === 'true';
      freeThreshold = parseInt(root.dataset.freeShippingThreshold, 10) || 0;
      continueUrl = root.dataset.continueUrl || '/';

      // direct checkout -> кнопка ведёт на /checkout вместо /cart
      var checkoutBtn = root.querySelector('[data-cart-checkout]');
      if (checkoutBtn && directCheckout) checkoutBtn.setAttribute('href', '/checkout');

      bind();
      fetchCart();

      window.DWDCart = { open: open, close: close, refresh: fetchCart };
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    // повторная инициализация в редакторе тем
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target && e.target.querySelector && e.target.querySelector('#DWDCartDrawer')) init();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function () {
    var section = document.querySelector('.cart-page');
    if (!section) return;
    var sectionId = section.dataset.sectionId;
    var itemsWrap = document.getElementById('cartItems');
    if (!itemsWrap || !sectionId) return;

    var busy = false;

    /* ── Обновить количество строки через Cart API ── */
    function changeLine(key, qty) {
      if (busy) return;
      busy = true;
      section.classList.add('is-loading');

      fetch(window.location.pathname + '?section_id=' + sectionId, { method: 'GET' }); /* прогрев кэша секции */

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          id: key,
          quantity: qty,
          sections: sectionId,
          sections_url: window.location.pathname
        })
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          /* корзина опустела → перезагрузка покажет пустое состояние */
          if (data.item_count === 0) {
            window.location.reload();
            return;
          }
          var html = data.sections && data.sections[sectionId];
          if (!html) { window.location.reload(); return; }

          var doc = new DOMParser().parseFromString(html, 'text/html');

          var newItems = doc.getElementById('cartItems');
          if (newItems) itemsWrap.innerHTML = newItems.innerHTML;

          swapText(doc, '[data-cart-subtotal]');
          swapText(doc, '[data-cart-count]');
        })
        .catch(function () { window.location.reload(); })
        .finally(function () {
          busy = false;
          section.classList.remove('is-loading');
        });
    }

    function swapText(doc, selector) {
      var fresh = doc.querySelector(selector);
      var cur = section.querySelector(selector);
      if (fresh && cur) cur.textContent = fresh.textContent;
    }

    /* ── Делегирование по списку (переживает подмену innerHTML) ── */
    itemsWrap.addEventListener('click', function (e) {
      var row = e.target.closest('.cart-item');
      if (!row) return;
      var key = row.dataset.key;
      var input = row.querySelector('[data-qty-input]');
      var current = parseInt(input.value, 10) || 1;

      if (e.target.closest('[data-qty-up]')) {
        changeLine(key, current + 1);
      } else if (e.target.closest('[data-qty-down]')) {
        changeLine(key, Math.max(0, current - 1)); /* 0 = удалить строку */
      } else if (e.target.closest('[data-remove]')) {
        changeLine(key, 0);
      }
    });

    /* ручной ввод количества — применяем по change/blur */
    itemsWrap.addEventListener('change', function (e) {
      if (!e.target.matches('[data-qty-input]')) return;
      var row = e.target.closest('.cart-item');
      var val = parseInt(e.target.value, 10);
      if (isNaN(val) || val < 0) val = 1;
      changeLine(row.dataset.key, val);
    });

    /* ── Комментарий к заказу → /cart/update.js на blur ── */
    var note = document.querySelector('[data-cart-note]');
    if (note) {
      note.addEventListener('blur', function () {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ note: note.value })
        });
      });
    }

    /* ── Промокод → редирект на /discount/CODE ── */
    var promoBtn = document.getElementById('cartPromoBtn');
    var promoInput = document.getElementById('cartPromo');
    if (promoBtn && promoInput) {
      function applyPromo() {
        var code = promoInput.value.trim();
        if (!code) return;
        window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + window.location.pathname;
      }
      promoBtn.addEventListener('click', applyPromo);
      promoInput.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); applyPromo(); }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var section = document.querySelector('.collection-grid');
    var sectionId = section ? section.dataset.sectionId : null;
    var filterPanel = document.getElementById('cgFilters');
    var overlay = document.getElementById('cgFiltersOverlay');
    var closeBtn = document.getElementById('cgFiltersClose');
    var applyBtn = document.getElementById('cgFiltersApply');
    var filterBtnDesktop = document.getElementById('cgFilterBtn');
    var filterBtnMobile = document.getElementById('cgFilterBtnMobile');

    if (!filterPanel) return;

    /* ── Открытие / закрытие панели ── */
    function openFilters() {
      filterPanel.classList.add('is-open');
      filterPanel.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
    function closeFilters() {
      filterPanel.classList.remove('is-open');
      filterPanel.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
    if (filterBtnDesktop) filterBtnDesktop.addEventListener('click', openFilters);
    if (filterBtnMobile) filterBtnMobile.addEventListener('click', openFilters);
    if (closeBtn) closeBtn.addEventListener('click', closeFilters);
    if (overlay) overlay.addEventListener('click', closeFilters);

    /* ── Текущее состояние фильтров → query ── */
    function buildQuery() {
      var params = new URLSearchParams();
      filterPanel.querySelectorAll('.collection-filters__checkbox:checked').forEach(function (cb) {
        params.append(cb.name, cb.value);
      });
      filterPanel.querySelectorAll('.collection-filters__price-input').forEach(function (pi) {
        if (pi.value.trim() !== '') params.append(pi.name, pi.value.trim());
      });
      var sort = new URLSearchParams(window.location.search).get('sort_by');
      if (sort) params.append('sort_by', sort);
      return params.toString();
    }

    /* ── Рендер секции через Section Rendering API ── */
    var controller = null;

    function render(query, pushHistory) {
      var newUrl = window.location.pathname + (query ? '?' + query : '');

      if (!sectionId) {
        window.location.href = newUrl; /* фолбэк на полную перезагрузку */
        return;
      }
      if (controller) controller.abort();
      controller = new AbortController();
      section.classList.add('is-loading');

      var fetchUrl =
        window.location.pathname + '?' + (query ? query + '&' : '') + 'section_id=' + sectionId;

      fetch(fetchUrl, { signal: controller.signal })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');

          /* товарные карточки — баннер НЕ трогаем, чтобы не сорвать листенеры кнопок */
          var newInner = doc.querySelector('.collection-grid__inner');
          var curInner = section.querySelector('.collection-grid__inner');
          if (newInner && curInner) {
            curInner.querySelectorAll('.product-slider__card').forEach(function (n) { n.remove(); });
            newInner.querySelectorAll('.product-slider__card').forEach(function (card) {
              curInner.appendChild(card);
            });
          }

          /* тело фильтров — обновляем счётчики / disabled / checked */
          var newBody = doc.querySelector('.collection-filters__body');
          var curBody = filterPanel.querySelector('.collection-filters__body');
          if (newBody && curBody) {
            var openGroups = [];
            curBody.querySelectorAll('.collection-filters__group-title.is-open').forEach(function (t) {
              openGroups.push(t.textContent.trim());
            });
            var scrollTop = curBody.scrollTop;
            curBody.innerHTML = newBody.innerHTML;
            curBody.querySelectorAll('.collection-filters__group-title').forEach(function (t) {
              if (openGroups.indexOf(t.textContent.trim()) !== -1) {
                t.classList.add('is-open');
                if (t.nextElementSibling) t.nextElementSibling.classList.add('is-open');
              }
            });
            curBody.scrollTop = scrollTop;
          }

          if (pushHistory) history.pushState({ dwdFilter: true }, '', newUrl);
        })
        .catch(function (err) {
          if (err.name === 'AbortError') return;
          window.location.href = newUrl;
        })
        .finally(function () {
          section.classList.remove('is-loading');
        });
    }

    /* ── Дебаунс тапов ── */
    var debounceTimer;
    function scheduleApply() {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () { render(buildQuery(), true); }, 350);
    }

    /* Делегирование — переживает подмену innerHTML тела фильтров, ребайнд не нужен */
    filterPanel.addEventListener('change', function (e) {
      if (
        e.target.classList.contains('collection-filters__checkbox') ||
        e.target.classList.contains('collection-filters__price-input')
      ) {
        scheduleApply();
      }
    });

    filterPanel.addEventListener('click', function (e) {
      var toggle = e.target.closest('[data-filter-toggle]');
      if (toggle) {
        toggle.classList.toggle('is-open');
        var body = toggle.nextElementSibling;
        if (body) body.classList.toggle('is-open');
      }
    });

    /* "Anwenden" теперь применяет сразу и закрывает панель */
    if (applyBtn) {
      applyBtn.addEventListener('click', function () {
        clearTimeout(debounceTimer);
        render(buildQuery(), true);
        closeFilters();
      });
    }

    /* назад / вперёд в браузере */
    window.addEventListener('popstate', function () {
      var p = new URLSearchParams(window.location.search);
      p.delete('section_id');
      render(p.toString(), false);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collections-mosaic"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function updateMosaic() {
      if (window.innerWidth <= 768) return;
      document.querySelectorAll('.collections-mosaic').forEach(function (el) {
        var bigCard = el.querySelector('.collections-mosaic__card--1');
        if (!bigCard) return;
        var width = bigCard.offsetWidth;
        var maxH = window.innerHeight;
        var rowH = Math.min(width, maxH) / 2;
        el.style.gridTemplateRows = rowH + 'px ' + rowH + 'px';
      });
    }

    function resetMosaic() {
      document.querySelectorAll('.collections-mosaic').forEach(function (el) {
        el.style.gridTemplateRows = '';
      });
    }

    function handleResize() {
      if (window.innerWidth <= 768) {
        resetMosaic();
      } else {
        updateMosaic();
      }
    }

    document.addEventListener('DOMContentLoaded', handleResize);
    window.addEventListener('resize', handleResize);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-accordion"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.pacc__item').forEach(function (item) {
      if (item._initialized) return;
      item._initialized = true;

      var btn = item.querySelector('.pacc__question');
      var iconDown = item.querySelector('.pacc__icon-down');
      var iconUp = item.querySelector('.pacc__icon-up');

      btn.addEventListener('click', function () {
        var isOpen = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', isOpen);
        iconDown.style.display = isOpen ? 'none' : '';
        iconUp.style.display = isOpen ? '' : 'none';
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var header = document.querySelector('.site-header');
    if (!header) return;
    var overlay = header.querySelector('.site-header__overlay');
    var burger = header.querySelector('.site-header__burger');
    if (!overlay || !burger) return;

    overlay.addEventListener('click', function () {
      if (header.classList.contains('is-open')) {
        burger.click(); /* переиспользуем штатный тоггл бургера — состояние не рассинхронится */
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slider"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const track = document.getElementById('heroTrack');
    const dots = document.querySelectorAll('.hero-slider__dot');
    let current = 0;
    let timer;

    function goTo(index) {
      current = index;
      track.style.transform = 'translateX(-' + 100 * current + '%)';
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === current);
      });
    }

    function next() {
      goTo((current + 1) % dots.length);
    }

    function prev() {
      goTo((current - 1 + dots.length) % dots.length);
    }

    function startTimer() {
      timer = setInterval(next, 5000);
    }

    function resetTimer() {
      clearInterval(timer);
      startTimer();
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(parseInt(this.dataset.index));
        resetTimer();
      });
    });

    var swipeArea = document.querySelector('.hero-slider') || track;
    var startX = 0;
    var startY = 0;
    var swiping = false;

    swipeArea.addEventListener('dragstart', function (e) {
      e.preventDefault();
    });

    swipeArea.addEventListener('pointerdown', function (e) {
      swiping = true;
      startX = e.clientX;
      startY = e.clientY;
    });

    swipeArea.addEventListener('pointerup', function (e) {
      if (!swiping) return;
      swiping = false;
      var dx = e.clientX - startX;
      var dy = e.clientY - startY;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) {
        if (dx < 0) {
          next();
        } else {
          prev();
        }
        resetTimer();
      }
    });

    startTimer();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
  (function () {
    var section = document.querySelector('.dwd-search');
    if (!section) return;
    var sectionId = section.dataset.sectionId;
    var form = section.querySelector('.dwd-search__form');
    var input = section.querySelector('.dwd-search__input');
    var submitBtn = section.querySelector('.dwd-search__submit');
    var results = document.getElementById('dwdSearchResults');
    if (!sectionId || !input || !results) return;

    var MIN = 1;             /* ищем с первого символа */
    var controller = null;
    var debounceTimer;

    function toggleIcon() {
      form.classList.toggle('has-value', input.value.trim() !== '');
    }

    function wildcard(term) {
      return term.trim().split(/\s+/).map(function (w) { return w + '*'; }).join(' ');
    }

    function run(term, updateUrl) {
      var raw = term.trim();

      if (raw === '') {
        results.innerHTML = '';
        history.replaceState({}, '', window.location.pathname);
        return;
      }
      if (raw.length < MIN) return;

      var wq = wildcard(raw);
      var params = 'q=' + encodeURIComponent(wq) + '&type=product';
      var pageUrl = window.location.pathname + '?' + params;
      var fetchUrl = pageUrl + '&section_id=' + sectionId;

      if (controller) controller.abort();
      controller = new AbortController();
      section.classList.add('is-searching');

      fetch(fetchUrl, { signal: controller.signal })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.getElementById('dwdSearchResults');
          if (fresh) results.innerHTML = fresh.innerHTML;
          if (updateUrl) history.replaceState({}, '', pageUrl);
        })
        .catch(function (err) {
          if (err.name !== 'AbortError') form.submit();
        })
        .finally(function () {
          section.classList.remove('is-searching');
        });
    }

    input.addEventListener('input', function () {
      toggleIcon();
      clearTimeout(debounceTimer);
      var val = input.value;
      debounceTimer = setTimeout(function () { run(val, true); }, 250);
    });

    /* пустое поле — кнопка = поиск; заполненное — кнопка = очистка */
    submitBtn.addEventListener('click', function (e) {
      if (input.value.trim() !== '') {
        e.preventDefault();
        input.value = '';
        toggleIcon();
        input.focus();
        run('', false);
      }
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      clearTimeout(debounceTimer);
      run(input.value, true);
    });

    toggleIcon();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["materials-grid"] && !Shopify.designMode) return;
  try {
    
(function () {
  var track = document.getElementById('mgCards');
  var nav = document.getElementById('mgNav');
  if (!track) return;

  var raw = track.getAttribute('data-materials');
  if (!raw) return;

  var materials;
  try {
    materials = JSON.parse(raw);
  } catch (e) {
    return;
  }

  materials.forEach(function (item) {
    var card = document.createElement('div');
    card.className = 'materials-grid__card';
    card.innerHTML =
      '<div class="materials-grid__image-wrap">' +
        '<img src="' + (item.image || '') + '" alt="' + (item.title || '') + '" loading="lazy" width="800" height="800">' +
        '<div class="materials-grid__image-overlay">' +
          '<p class="materials-grid__image-title t-subtitle--bold">' + (item.title || '') + '</p>' +
        '</div>' +
      '</div>' +
      '<div class="materials-grid__content">' +
        '<p class="materials-grid__excerpt t-body">' + (item.text || '') + '</p>' +
      '</div>';
    track.appendChild(card);
  });

  /* Слайдер — остаётся без изменений */
  var cards = track.querySelectorAll('.materials-grid__card');
  var total = cards.length;
  if (!total || !nav) return;

  var isTablet = window.innerWidth <= 1024;
  var visibleCount = isTablet ? 3 : 4;

  if (total > visibleCount) nav.style.display = 'flex';

  var progress = nav.querySelector('.product-slider__progress-fill');
  var btnPrev = nav.querySelector('.product-slider__btn-nav--prev');
  var btnNext = nav.querySelector('.product-slider__btn-nav--next');
  var current = 0;
  var maxIndex = Math.max(0, total - visibleCount);

  function getCardWidth() {
    var gap = parseInt(getComputedStyle(track).gap) || 0;
    return cards[0] ? cards[0].offsetWidth + gap : 0;
  }

  function update() {
    track.style.transform = 'translateX(-' + current * getCardWidth() + 'px)';
    var thumbWidth = total <= visibleCount ? 100 : (visibleCount / total) * 100;
    var thumbLeft = total <= visibleCount ? 0 : (current / maxIndex) * (100 - thumbWidth);
    if (progress) {
      progress.style.width = thumbWidth + '%';
      progress.style.left = thumbLeft + '%';
    }
    if (btnPrev) btnPrev.classList.toggle('is-inactive', current === 0);
    if (btnNext) btnNext.classList.toggle('is-inactive', current >= maxIndex);
  }

  if (btnPrev) btnPrev.addEventListener('click', function () {
    if (current > 0) { current--; update(); }
  });
  if (btnNext) btnNext.addEventListener('click', function () {
    if (current < maxIndex) { current++; update(); }
  });

  update();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-accordion"] && !Shopify.designMode) return;
  try {
    
(function () {
  var list = document.getElementById('paccList');
  if (!list) return;

  var raw = list.getAttribute('data-properties');
  if (!raw) { console.warn('[pacc] data-properties пустой'); return; }

  var items;
  try {
    items = JSON.parse(raw);
    if (typeof items === 'string') items = JSON.parse(items); // текстовое метаполе → парсим дважды
  } catch (e) {
    console.warn('[pacc] не удалось распарсить:', raw, e);
    return;
  }

  if (!Array.isArray(items)) {
    console.warn('[pacc] ожидался массив [{question, answer}], пришло:', items);
    return;
  }
  if (!items.length) return;

  items.forEach(function (item, i) {
    var q = item.question || item.title || item.name || item.label || item.key || '';
    var a = item.answer || item.text || item.value || item.content || item.description || item.val || '';

    if (i > 0) {
      var divider = document.createElement('div');
      divider.className = 'pacc__item-divider';
      list.appendChild(divider);
    }
    var el = document.createElement('div');
    el.className = 'pacc__item';
    el.innerHTML =
      '<button class="pacc__question" aria-expanded="false">' +
        '<span class="pacc__question-text t-subtitle--bold">' + q + '</span>' +
        '<span class="pacc__question-icon pacc__icon-down"><svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><polyline points="6 9 12 15 18 9"/></svg></span>' +
        '<span class="pacc__question-icon pacc__icon-up" style="display:none"><svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><polyline points="18 15 12 9 6 15"/></svg></span>' +
      '</button>' +
      '<div class="pacc__answer t-caption">' + a + '</div>';
    list.appendChild(el);

    var btn = el.querySelector('.pacc__question');
    var iconDown = el.querySelector('.pacc__icon-down');
    var iconUp = el.querySelector('.pacc__icon-up');
    btn.addEventListener('click', function () {
      var isOpen = el.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', isOpen);
      iconDown.style.display = isOpen ? 'none' : '';
      iconUp.style.display = isOpen ? '' : 'none';
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-main"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* Переключение миниатюр (таблет/мобайл) */
    var thumbs = document.querySelectorAll('.product-main__thumb');
    var mainImg = document.getElementById('pmMainImg');

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        thumbs.forEach(function (t) {
          t.classList.remove('is-active');
        });
        thumb.classList.add('is-active');
        if (mainImg) mainImg.src = thumb.dataset.src;
      });
    });

    /* Переключение вариантов */
    var variantBtns = document.querySelectorAll('.product-main__variant');
    var priceEl = document.getElementById('pmPrice');
    var priceOldEl = document.getElementById('pmPriceOld');
    var variantIdEl = document.getElementById('pmVariantId');
    var stickyPriceEl = document.querySelector('.product-main__sticky-price');

    variantBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        variantBtns.forEach(function (b) {
          b.classList.remove('is-active');
        });
        btn.classList.add('is-active');

        var price = btn.dataset.variantPrice;
        var compare = btn.dataset.variantCompare;

        if (priceEl) priceEl.textContent = price;
        if (stickyPriceEl) stickyPriceEl.textContent = price;
        if (variantIdEl) variantIdEl.value = btn.dataset.variantId;

        if (priceOldEl) {
          if (compare) {
            priceOldEl.textContent = compare;
            priceOldEl.hidden = false;
            priceOldEl.style.display = '';
          } else {
            priceOldEl.style.display = 'none';
          }
        }

        var img = btn.dataset.variantImg;
        if (img && mainImg) mainImg.src = img;
        var desktopFirstImg = document.querySelector('.product-main__slide--main img');
        if (img && desktopFirstImg) desktopFirstImg.src = img;

        /* Обновление спецификаций */
        var title = (btn.dataset.variantTitle || '').trim();
        if (title === 'Default Title' || title.toLowerCase() === 'nan') title = '';
        var sku = (btn.dataset.variantSku || '').trim();
        updateSpec('[data-spec="variant"]', title ? title + (sku ? ' (' + sku + ')' : '') : null);

        var freetext = btn.dataset.variantFreetext;
        if (freetext === 'Produkt Daten') freetext = null;
        updateSpec('[data-spec="freetext"]', freetext);
        updateSpec('[data-spec="colors"]', btn.dataset.variantColors);
        updateSpec(
          '[data-spec="size"]',
          btn.dataset.variantWidth
            ? btn.dataset.variantWidth + 'B x ' + btn.dataset.variantDepth + 'T x ' + btn.dataset.variantHeight + 'H'
            : null
        );
        updateSpec('[data-spec="material"]', btn.dataset.variantMaterial);
        updateSpec(
          '[data-spec="weight"]',
          btn.dataset.variantWeight
            ? btn.dataset.variantWeight + ' netto, ' + btn.dataset.variantWeightBrutto + ' brutto kg'
            : null
        );
        updateSpec('[data-spec="ean"]', btn.dataset.variantSku || null);
      });
    });

    function updateSpec(selector, value) {
      document.querySelectorAll(selector).forEach(function (el) {
        var row = el.closest('.product-main__spec-row');
        if (value && value.trim()) {
          el.textContent = value;
          if (row) row.style.display = '';
        } else {
          el.textContent = '';
          if (row) row.style.display = 'none';
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-slider"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sliders = document.querySelectorAll('.product-slider');
    sliders.forEach(function (section) {
      var track = section.querySelector('.product-slider__track');
      var progress = section.querySelector('.product-slider__progress-fill');
      var btnPrev = section.querySelector('.product-slider__btn-nav--prev');
      var btnNext = section.querySelector('.product-slider__btn-nav--next');

      if (!track || !btnPrev || !btnNext) return;

      var cards = track.querySelectorAll('.product-slider__card');
      var total = cards.length;
      var current = 0;
      var visibleCount = window.innerWidth <= 1024 ? 3 : 4;
      var maxIndex = Math.max(0, total - visibleCount);

      function getCardWidth() {
        var gap = parseInt(getComputedStyle(track).gap) || 0;
        return cards[0] ? cards[0].offsetWidth + gap : 0;
      }

      function update() {
        track.style.transform = 'translateX(-' + current * getCardWidth() + 'px)';
        var thumbWidth = total <= visibleCount ? 100 : (visibleCount / total) * 100;
        var thumbLeft = total <= visibleCount ? 0 : (current / maxIndex) * (100 - thumbWidth);
        if (progress) {
          progress.style.width = thumbWidth + '%';
          progress.style.left = thumbLeft + '%';
        }
        btnPrev.classList.toggle('is-inactive', current === 0);
        btnNext.classList.toggle('is-inactive', current >= maxIndex);
      }

      btnPrev.addEventListener('click', function () {
        if (current > 0) {
          current--;
          update();
        }
      });

      btnNext.addEventListener('click', function () {
        if (current < maxIndex) {
          current++;
          update();
        }
      });

      update();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews-slider"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.addEventListener('DOMContentLoaded', function () {
      if (window.innerWidth <= 768) return;

      var sections = document.querySelectorAll('.reviews-slider');
      sections.forEach(function (section) {
        var track = section.querySelector('.reviews-slider__track');
        var progress = section.querySelector('.reviews-slider__progress-fill');
        var btnPrev = section.querySelector('.reviews-slider__btn-nav--prev');
        var btnNext = section.querySelector('.reviews-slider__btn-nav--next');
        var textEl = section.querySelector('[id^="rsText"]');
        var authorEl = section.querySelector('[id^="rsAuthor"]');
        var starsEl = section.querySelector('[id^="rsStars"]');

        if (!track) return;

        var photoCards = Array.from(track.querySelectorAll('.reviews-slider__photo-card'));
        var total = photoCards.length;
        var current = 0;
        var currentActive = 0;
        var visiblePhotos = window.innerWidth <= 1024 ? 2 : 3;
        var maxIndex = Math.max(0, total - visiblePhotos);

        function getCardWidth() {
          var gap = parseInt(getComputedStyle(track).gap) || 0;
          return photoCards[0] ? photoCards[0].offsetWidth + gap : 0;
        }

        function updateStars(rating) {
          if (!starsEl) return;
          starsEl.querySelectorAll('svg').forEach(function (star, i) {
            star.setAttribute('fill', i < rating ? 'var(--color-accent)' : 'var(--color-gray400)');
          });
        }

        function updateReview(index) {
          var card = photoCards[index];
          if (!card) return;
          photoCards.forEach(function (c) {
            c.classList.remove('is-active');
          });
          card.classList.add('is-active');
          if (textEl) textEl.textContent = card.dataset.text;
          if (authorEl) authorEl.textContent = '— ' + card.dataset.author;
          updateStars(parseInt(card.dataset.rating) || 5);
        }

        function updateProgress() {
          if (!progress) return;
          var thumbWidth = total <= visiblePhotos ? 100 : (visiblePhotos / total) * 100;
          var thumbLeft = total <= visiblePhotos ? 0 : (current / maxIndex) * (100 - thumbWidth);
          progress.style.width = thumbWidth + '%';
          progress.style.left = thumbLeft + '%';
        }

        function goTo(index) {
          current = Math.max(0, Math.min(index, maxIndex));
          track.style.transition = 'transform 0.5s cubic-bezier(0.77, 0, 0.175, 1)';
          track.style.transform = 'translateX(-' + current * getCardWidth() + 'px)';
          updateProgress();
          if (btnPrev) btnPrev.classList.toggle('is-inactive', currentActive === 0);
          if (btnNext) btnNext.classList.toggle('is-inactive', currentActive === total - 1);
        }

        photoCards.forEach(function (card, i) {
          card.addEventListener('click', function () {
            currentActive = i;
            updateReview(i);
            goTo(Math.min(i, maxIndex));
          });
        });

        if (btnPrev)
          btnPrev.addEventListener('click', function () {
            var newActive = Math.max(0, /* текущий активный */ currentActive - 1);
            currentActive = newActive;
            updateReview(currentActive);
            goTo(Math.min(currentActive, maxIndex));
          });

        if (btnNext)
          btnNext.addEventListener('click', function () {
            var newActive = Math.min(total - 1, currentActive + 1);
            currentActive = newActive;
            updateReview(currentActive);
            goTo(Math.min(currentActive, maxIndex));
          });

        goTo(0);
        updateReview(0);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
